// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-v3/accolades-list-v3.component.scss
// module id = 777
// module chunks = 0